/* eslint-disable no-unused-vars */
import { useState } from 'react';
import Select from 'react-select';
import { reportTypes } from '../../constants/enums/Reports';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import classNames from 'classnames';
import { exportToExcel } from '../../utils/Downloader/Downloader';
import { toast } from 'react-toastify';
import loadingGif from '../../assets/Other/loading.gif';

const Reports = ({ swalModal }) => {
  const [container, setContainer] = useState('');
  const [loading, setLoading] = useState(false);
  const [format, setFormat] = useState(reportTypes['packingList'].id);

  const showSwal = (type, container) => {
    swalModal.fire({
      title: 'No data found!',
      text: `No data found for ${reportTypes[type]?.name} report in container ${container}`,
      icon: 'error',
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: 'Ok',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-[400px] text-sm',
      },
    });
  };

  const download = async () => {
    if (container.length > 0) {
      const result = await request({
        url: `${controllers.report}getReport`,
        type: requestTypes.post,
        body: { format, container },
        setLoading,
      });
      if (
        result?.code !== responseTypes.error &&
        (result?.length > 0 || result?.l?.length > 0 || result?.z?.length > 0)
      ) {
        if (format !== 'lz') {
          exportToExcel(result, `${reportTypes[format].fileName}-${container}`);
          toast.info(`Report saved!`, {
            autoClose: 2000,
          });
        } else {
          exportToExcel(result.l, `Z-report-${container}`);
          exportToExcel(result.z, `L-report-${container}`);
        }
      } else {
        showSwal(format, container);
      }
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '20px',
      paddingLeft: '20px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
    }),

    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  const selectOptions = Object.keys(reportTypes).map((item) => ({
    value: reportTypes[item].id,
    label: reportTypes[item].name.toUpperCase(),
  }));
  return (
    <div>
      <div className="m-5 text-xl text-blue-800">REPORTS</div>
      <div className="m-5 text-md text-blue-800">CONTAINER:</div>
      <input
        maxLength={15}
        value={container}
        onChange={(e) =>
          setContainer(e.target.value.replace(/[^a-zA-Z0-9-]/g, ''))
        }
        type="text"
        placeholder="Format - 9999A..."
        className="border-b-[1px] border-blue-800 px-4 mb-5 focus:outline-none focus:border-b-[1px] focus:border-blue-400 relative"
      />
      <div className="m-5 text-md text-blue-800">CHOOSE REPORT FORMAT</div>

      <Select
        value={selectOptions.find((option) => option.value === format)}
        onChange={(selectedOption) => setFormat(selectedOption.value)}
        options={selectOptions}
        className="w-[250px] mx-auto mb-10 text-center"
        classNamePrefix="custom-select"
        placeholder="Choose format..."
        styles={customStyles}
      />
      <div
        onClick={download}
        className={classNames(
          'inline-block text-white px-10 rounded-xl',
          container.length > 0
            ? 'bg-red-800 hover:bg-red-900 hover:transition-all hover:duration-300 cursor-pointer'
            : 'bg-gray-400',
          loading ? 'hidden' : null,
        )}
      >
        DOWNLOAD
      </div>
      <div
        className={classNames(
          'w-full flex justify-center items-center',
          !loading ? 'hidden' : null,
        )}
      >
        <img className="w-8 h-8" src={loadingGif} />
      </div>
      <div
        className={classNames('mt-5 text-gray-400', !loading ? 'hidden' : null)}
      >
        Please wait, processing large amount
        <br /> of data might take some time....
      </div>
    </div>
  );
};

export default Reports;
